import React, { useState, useEffect } from "react";
import Skeleton from '../Components/SkeletonLoader'
import { getUsersSubscribers } from "../Services/userService";
import { NavLink } from "react-router-dom";
import { RoutesPaths } from "../Router/constant";
export default function Subscribermanagement() {
    const [loading, setLoading] = useState(true);
    const [userSubscriberData, setUserSubscriberData] = useState([]);
    const [offset, setOffset] = useState(1);
    const [limit] = useState(10);
    const [search, setSearch] = useState("");
    const [totalCount, setTotalCount] = useState(0);

    const fetchAllData = async () => {
        setLoading(true);
        try {
            const userSubscribersResp = await getUsersSubscribers({ offset, limit, search });
            const subscribers = userSubscribersResp.data?.data?.subscribers || [];
            setUserSubscriberData(subscribers);
            setTotalCount(userSubscribersResp?.data?.data?.count || 0);
        } catch (error) {
            console.error("Error fetching subscribers:", error);
            setUserSubscriberData([]);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchAllData();
    }, [offset, search]);

    return (
        <>
            <div className="container-fluid">
                <div className="row dashboardSection">
                    <div className="logisticsMenu">
                        <p>
                        <NavLink to={RoutesPaths.DASHBOARD}>
                            <img src="/assets/img/homeIcon.svg" alt="" />
                        </NavLink>
                        </p>
                        <img src="/assets/img/chevron-right.svg" alt="" />
                        <p>
                            Newsletter management
                        </p>
                    </div>
                    <div className="col-md-12 bookingDetailsMain">
                        <div className="bookingDetailsOuter">
                            <div className="bookingDetailsAlign">
                                <h6 className="bookingDetailsTitle p-0">Newsletter details</h6>
                                <div className="bookingDetailsOuterRight">

                                    <div>
                                        <input
                                            type="text"
                                            placeholder="Search"
                                            className="searchInput"
                                            value={search}
                                            onChange={(e) => setSearch(e.target.value)}
                                        />  

                                    </div>
                                </div>
                            </div>
                            <div className="TableOverFlow">
                                <div className="bookingContent bookingDetailsHeader bookingContentSubscription">
                                    <div className="m-0 userEmailWidth reponsiveEmailWidth">Customer email</div>
                                    <div className="m-0 statusWidth">Date</div>
                                </div>

                                <div>

                                    {loading ? (
                                        [...Array(5)].map((_, i) => (
                                            <div className="bookingContent bookingContentData bookingContentSubscription">
                                                <div className="m-0 userEmailWidth reponsiveEmailWidth"><Skeleton width={200} /></div>
                                                <div className="m-0 statusWidth"><Skeleton width={100} /></div>
                                            </div>
                                        ))
                                    ) : userSubscriberData.length > 0 ? (
                                        userSubscriberData.map((subscriber) => {
                                            return (
                                                <div className="bookingContent bookingContentData bookingContentSubscription" key={subscriber._id}>
                                                    <div className="m-0 userEmailWidth reponsiveEmailWidth">{subscriber.email}</div>
                                                    <div className="m-0 statusWidth">
                                                        {new Date(subscriber.createdAt).toLocaleDateString('en-GB')}
                                                    </div>
                                                </div>
                                            );
                                        })
                                    ) : (
                                        <p className="noOrders">No subscribers Found</p>
                                    )}


                                </div>

                            </div>

                            {totalCount > 0 && Math.ceil(totalCount / limit) > 1 && (
                                <div className="paginationSection">
                                    <p
                                        onClick={() => offset > 1 && setOffset(offset - 1)}
                                        style={{
                                            opacity: offset > 1 ? 1 : 0.5,
                                            pointerEvents: offset > 1 ? "auto" : "none",
                                            cursor: offset > 1 ? "pointer" : "default"
                                        }}
                                    >
                                        <img src="/assets/img/arrow-left.svg" alt="Previous" />
                                    </p>

                                    {[...Array(Math.ceil(totalCount / limit))].map((_, index) => (
                                        <p
                                            key={index}
                                            onClick={() => setOffset(index + 1)}
                                            style={{
                                                fontWeight: offset === index + 1 ? "bold" : "normal",
                                                cursor: "pointer"
                                            }}
                                        >
                                            {index + 1}
                                        </p>
                                    ))}

                                    <p
                                        onClick={() => offset < Math.ceil(totalCount / limit) && setOffset(offset + 1)}
                                        style={{
                                            opacity: offset < Math.ceil(totalCount / limit) ? 1 : 0.5,
                                            pointerEvents: offset < Math.ceil(totalCount / limit) ? "auto" : "none",
                                            cursor: offset < Math.ceil(totalCount / limit) ? "pointer" : "default"
                                        }}
                                    >
                                        <img src="/assets/img/arrow-right.svg" alt="Next" />
                                    </p>
                                </div>
                            )}

                        </div>
                    </div>
                </div>

            </div>
        </>
    );
}
